module.exports = __webpack_public_path__ + "img/settings-fill.82b0ea34.svg";